import CustomSelect, { CustomSelectItem } from "compid/custom-ui/CustomSelect";
import ActivityFilter from "compid/pages/ActivityPage/classes/ActivityFilter";
import React from "react";
import { useFilterBarContext } from "../..";
import "./styles.css";
/**
 * @function FilterCustomSelect
 * @description This is a variation of the CustomSelect component for specifically the activity filter.
 * @param {STRING} className Allows us to set a className for the select. 
 * @param {children} children Allows us to add CustomSelectItems to the select.
 * @returns {React.Component}
 */
export function FilterCustomSelect(props) {
  const className = props.className ?? "";

  const onChange = val => {
    if(props.onChange instanceof Function) props.onChange(val);
  };

  return (
    <CustomSelect className={`${className} filter-custom-select`} label="" dataPoint={ props.dataPoint } helpText="" onChange={ onChange } value={props.value}>
      {props.children}
    </CustomSelect>
  )
};

/**
 * @function StatusFilterCustomSelect
 * @description This is the status filter select for the activity filter.
 * @returns {React.Component}
 */
export function StatusFilterCustomSelect(props) {
  const { state, setRadioStatusFilter } = useFilterBarContext();

  const onChange = val => {
    if(setRadioStatusFilter instanceof Function) setRadioStatusFilter(val);
  }
  
  return (
    // functionality should come from the FilterRadioButton
    <FilterCustomSelect className="status-filter-custom-select" onChange={ onChange } value={ state.status }>
      <CustomSelectItem value="All">All</CustomSelectItem>
      <CustomSelectItem value="Scheduled">Scheduled</CustomSelectItem>
      <CustomSelectItem value="Processing">Processing</CustomSelectItem>
      <CustomSelectItem value="Processed">Processed</CustomSelectItem>
    </FilterCustomSelect>
  )
};

/**
 * @function SortByFilterCustomSelect
 * @description This is the sort by filter select for the activity filter.
 * @returns {React.Component}
 */
export function SortByFilterCustomSelect(props) {
  const { state, setRadioSortFilter } = useFilterBarContext();

  const onChange = val => {
    if(setRadioSortFilter instanceof Function) setRadioSortFilter(val);
  }

  return (
    // functionality should come from the FilterRadioButton
    <FilterCustomSelect className="sort-by-filter-custom-select" dataPoint="Activity_Filter_Sort_Select" onChange={ onChange } value={ state.sort }>
        <CustomSelectItem value="None" dataPoint="Activity_Filter_None">None</CustomSelectItem>
        <CustomSelectItem value="Date - Ascending" dataPoint="Activity_Date_Ascending">Date - Ascending</CustomSelectItem>
        <CustomSelectItem value="Date - Descending" dataPoint="Activity_Date_Descending">Date - Descending</CustomSelectItem>
        <CustomSelectItem value="Name - (A-Z)" dataPoint="Activity_Name_A_Z">Name - (A-Z)</CustomSelectItem>
        <CustomSelectItem value="Name - (Z-A)" dataPoint="Activity_Name_Z_A">Name - (Z-A)</CustomSelectItem>
      </FilterCustomSelect>
  )
};

/**
 * @function DateRangeFilterCustomSelect
 * @description This is the date range filter select for the activity filter.
 * @returns {React.Component}
 */
export function DateRangeFilterCustomSelect(props) {
  const { state, setCustomDateFilter, setDateFilter } = useFilterBarContext();
  const value = props.value ?? "";
  const hasCustomSelect = state.custom ?? false;
  const defaultDates = ActivityFilter.getCustomDefaultDates();
  const dateValue = state.date ? state.date.value : "-180";

  const onChange = value => {
    if(value === "custom") {
      if(setCustomDateFilter instanceof Function) {
        setCustomDateFilter({ value: defaultDates, label: ActivityFilter.getDateRangeLabel(value) })
      }
    } else {
      if(setDateFilter instanceof Function) {
        setDateFilter({ value, label: ActivityFilter.getDateRangeLabel(value) });
      }
    }
  }
  
  return (
    // functionality should come from the FilterRadioButton
    <FilterCustomSelect className="date-range-filter-custom-select" onChange={ onChange } value={ hasCustomSelect ? "custom" : dateValue }>
        <CustomSelectItem value="-180">Last 6 months</CustomSelectItem>
        <CustomSelectItem value="-30">30 days</CustomSelectItem>
        <CustomSelectItem value="-60">60 days</CustomSelectItem>
        <CustomSelectItem value="-90">90 days</CustomSelectItem>
        <CustomSelectItem value="-120">120 days</CustomSelectItem>
        <CustomSelectItem value="-365">1 year</CustomSelectItem>
        <CustomSelectItem value="-730">2 years</CustomSelectItem>
        <CustomSelectItem value="custom">Custom date range</CustomSelectItem>
      </FilterCustomSelect>
  )
};